<template>
    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card style="margin-bottom:10px">
                    <p slot="title">{{t.routerNamePic}}</p>
                    <a href="#" slot="extra" @click.prevent="changeShowCropper" v-if="formItem.category === ''">
                        <span :key="showCropper">
                            {{ !showCropper ? msgUtil.message.action.show : msgUtil.message.action.hide }}
                        </span>
                    </a>
                    <transition name="fade" mode="out-in">
                        <div v-show="showCropper">
                            <Row>
                                <div class="sub-cropper">
                                    <vueCropper
                                        ref="cropper"
                                        :img="option.img"
                                        :outputSize="option.outputSize"
                                        :outputType="option.outputType"
                                        :info="option.info"
                                        :full="option.full"
                                        :canMove="option.canMove"
                                        :canMoveBox="option.canMoveBox"
                                        :fixedBox="option.fixedBox"
                                        :original="option.original"
                                        :autoCrop="option.autoCrop"
                                        :autoCropWidth="option.autoCropWidth"
                                        :autoCropHeight="option.autoCropHeight"
                                        :centerBox="option.centerBox"
                                        :high="option.high"
                                        :infoTrue="option.infoTrue"
                                        @realTime="realTime"
                                        @imgLoad="imgLoad"
                                        @cropMoving="cropMoving"
                                        :enlarge="option.enlarge"
                                    ></vueCropper>
                                </div>
                            </Row>
                            <Row>
                                <Col style="text-align:right;">
                                    <Form :model="formItem" :rules="ruleValidate"
                                          ref="form1">
                                        <FormItem style="display:inline-block;margin-right:20px;">
                                            <RadioGroup v-model.trim="formItem.imageSizeIndex" type="button"
                                                        @on-change="onImageSizeChange">
                                                <Radio v-for="(imageSize,index) in imageSizeList"
                                                       :key="imageSize.range" :label="index">{{imageSize.name}}
                                                </Radio>
                                            </RadioGroup>
                                        </FormItem>
                                        <FormItem v-if="!showCropperButton" style="display:inline-block;">
                                            <Upload action="image/jpeg"
                                                    style="display:inline-block;margin-right:10px;">
                                                <Button type="success" disabled>
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Upload>
                                            <Button type="primary" disabled>
                                                {{msgUtil.message.action.upload}}
                                            </Button>
                                        </FormItem>
                                        <FormItem v-if="showCropperButton" style="display:inline-block;">
                                            <Upload action="image/jpeg" :before-upload="handleBeforeUpload"
                                                    style="display:inline-block;margin-right: 10px;">
                                                <Button type="success">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Upload>
                                            <Button type="primary" @click="handleUpload">
                                                {{msgUtil.message.action.upload}}
                                            </Button>
                                        </FormItem>
                                    </Form>
                                </Col>
                            </Row>
                        </div>
                    </transition>
                </Card>
            </Col>
        </Row>
        <Row :gutter="16">
            <Form :model="formItem" :rules="ruleValidate" :label-width="105" label-position="right"
                  ref="form">
                <Col span="18">
                    <Card>
                        <p slot="title">{{t.routerName}}</p>
                        <transition name="fade" mode="out-in">
                            <Row v-if="formItem.category !== ''">
                                <Col span="24">
                                <span v-for="step in 8" :key="step" style="float: right;">
                                    <div class="article-upload-list">
                                        <img :src="showDictThumb(step)"/>
                                        <div class="article-upload-list-cover">
                                            <Icon type="ios-eye-outline" @click="onShowDictThumbClick(step)"></Icon>
                                        </div>
                                    </div>
                                </span>
                                    <Modal v-model.trim="showImageFlg" :width="showImageModalWidth">
                                        <img :src="showImage" style="max-width:100%;max-height:100%;">
                                        <div slot="footer">
                                            {{showImageName}}
                                        </div>
                                    </Modal>
                                </Col>
                            </Row>
                        </transition>
                        <Row>
                            <Col>
                                <FormItem :label="t.article.category" prop="dictId">
                                    <Select v-model.trim="formItem.category"
                                            :placeholder="msgUtil.placeholderSelected(t.article.category)"
                                            @on-change="categoryChange" clearable>
                                        <Option v-for="(item,index) in dictArticleList" :value="index" :key="index">
                                            {{ item.label }}
                                        </Option>
                                    </Select>
                                </FormItem>
                                <div v-if="showMustItem">
                                    <FormItem :label="t.article.thumb" prop="thumb">
                                        <Input v-model.trim="formItem.thumb" readonly>
                                            <Button slot="append" type="success"
                                                    @click="clearField">
                                                {{msgUtil.message.action.clear}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                    <FormItem :label="t.article.image" prop="image">
                                        <Input v-model.trim="formItem.image" readonly>
                                            <Button slot="append" type="success"
                                                    @click="clearField">
                                                {{msgUtil.message.action.clear}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                    <FormItem :label="t.article.top" prop="top">
                                        <Input v-model.trim="formItem.top" readonly>
                                            <Button slot="append" type="success"
                                                    @click="clearField">
                                                {{msgUtil.message.action.clear}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                </div>
                                <div v-if="!showMustItem">
                                    <FormItem :label="t.article.thumb" prop="thumb1" key="thumb1">
                                        <Input v-model.trim="formItem.thumb1" readonly>
                                            <Button slot="append" type="success"
                                                    @click="clearField">
                                                {{msgUtil.message.action.clear}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                    <FormItem :label="t.article.default" prop="image1" key="image1">
                                        <Input v-model.trim="formItem.image" readonly>
                                            <Button slot="append" type="success"
                                                    @click="clearField">
                                                {{msgUtil.message.action.clear}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                    <FormItem :label="t.article.top" prop="top1" key="top1">
                                        <Input v-model.trim="formItem.top" readonly>
                                            <Button slot="append" type="success"
                                                    @click="clearField">
                                                {{msgUtil.message.action.clear}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                </div>
                                <FormItem :label="t.article.hot" prop="hot">
                                    <Input v-model.trim="formItem.hot" readonly>
                                        <Button slot="append" type="success"
                                                @click="clearField">
                                            {{msgUtil.message.action.clear}}
                                        </Button>
                                    </Input>
                                </FormItem>
                                <FormItem :label="t.article.recommend" prop="recommend">
                                    <Input v-model.trim="formItem.recommend" readonly>
                                        <Button slot="append" type="success"
                                                @click="clearField">
                                            {{msgUtil.message.action.clear}}
                                        </Button>
                                    </Input>
                                </FormItem>
                                <FormItem :label="t.article.recommendTop" prop="recommendTop">
                                    <Input v-model.trim="formItem.recommendTop" readonly>
                                        <Button slot="append" type="success"
                                                @click="clearField">
                                            {{msgUtil.message.action.clear}}
                                        </Button>
                                    </Input>
                                </FormItem>
                                <FormItem :label="t.article.topic" prop="topic">
                                    <Input v-model.trim="formItem.topic" readonly>
                                        <Button slot="append" type="success"
                                                @click="clearField">
                                            {{msgUtil.message.action.clear}}
                                        </Button>
                                    </Input>
                                </FormItem>
                                <FormItem :label="t.article.slider" prop="slider">
                                    <Input v-model.trim="formItem.slider" readonly>
                                        <Button slot="append" type="success"
                                                @click="clearField">
                                            {{msgUtil.message.action.clear}}
                                        </Button>
                                    </Input>
                                </FormItem>
                                <Form-item :label="t.article.releaseTime" prop="releaseTime">
                                    <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                                v-model="formItem.releaseTime" style="width: 100% !important"
                                                :placeholder="msgUtil.placeholderRequired(t.article.releaseTime)"
                                                :editable="false"
                                                :options="releaseTimeOption"
                                                @on-change="onReleaseTimeChange"></DatePicker>
                                </Form-item>
                                <FormItem :label="t.article.title" prop="title">
                                    <Input v-model.trim="formItem.title" :maxlength="64"
                                           :placeholder="msgUtil.placeholderRequired(t.article.title)"></Input>
                                </FormItem>
                                <FormItem :label="t.article.author" prop="author">
                                    <Input v-model.trim="formItem.author" :maxlength="20"
                                           :placeholder="msgUtil.placeholderRequired(t.article.author)"></Input>
                                </FormItem>
                                <FormItem :label="t.article.description" prop="description">
                                    <Input v-model.trim="formItem.description" type="textarea" :rows="4"
                                           :maxlength="30000"
                                           :placeholder="msgUtil.placeholderRequired(t.article.description)"></Input>
                                </FormItem>
                                <FormItem :label="t.article.body">
                                    <tinymce id="id1" ref="tinymceArt" v-model.trim="formItem.body" :toolbar1="toolbar1"
                                             :other_options="other_options"></tinymce>
                                </FormItem>
                                <!-- </Form>-->
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col span="6">
                    <Card>
                        <p slot="title">
                            <Icon type="logo-buffer"/>
                            {{t.menu.title}}
                        </p>
                        <Row>
                            <Col style="height: 290px;overflow-x: auto;">
                                <Tree ref="tree" @on-select-change="selectedTreeNode" :data="menuList"></Tree>
                            </Col>
                        </Row>
                        <Row class="margin-top-10">
                            <Col>
                                <Alert v-if="treeNodeError" type="error" show-icon>
                                    {{msgUtil.placeholderSelected(t.menu.name)}}
                                </Alert>
                            </Col>
                        </Row>
                    </Card>
                    <Row class="margin-top-10">
                        <Card>
                            <p slot="title">
                                <Icon type="ios-paper-plane-outline"/>
                                {{t.menu.setting}}
                            </p>
                            <FormItem :label="t.article.tag" prop="tagIdList">
                                <Select v-model.trim="formItem.tagIdList" multiple
                                        :placeholder="msgUtil.placeholderSelected(t.article.tagName)">
                                    <Option v-for="item in tagList" :value="item.id" :key="item.id">
                                        {{ item.name }}
                                    </Option>
                                </Select>
                            </FormItem>
                            <FormItem :label="t.article.hits" prop="hits">
                                <InputNumber v-model.trim="formItem.hits" :max="9999999999" :min="0"></InputNumber>
                            </FormItem>
                            <FormItem :label="t.article.status" prop="status">
                                <Select v-model.trim="formItem.status">
                                    <Option value="0">{{t.article.status0}}</Option>
                                    <Option value="1">{{t.article.status1}}</Option>
                                    <Option value="2">{{t.article.status2}}</Option>
                                    <Option value="9">{{t.article.status9}}</Option>
                                </Select>
                            </FormItem>
                            <FormItem :label="t.article.charge" prop="charge">
                                <RadioGroup v-model.trim="formItem.charge">
                                    <Radio label="0">{{t.article.charge1}}</Radio>
                                    <Radio label="1">{{t.article.charge0}}</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem :label="t.article.disabled" prop="disabled">
                                <RadioGroup v-model.trim="formItem.disabled">
                                    <Radio label="0">{{t.article.yes}}</Radio>
                                    <Radio label="1">{{t.article.no}}</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem>
                                <Button type="primary" :loading="loading" @click="handleSubmit()">
                                    {{msgUtil.message.action.submit}}
                                </Button>
                                <Button @click="handleReset()" style="margin-left: 8px">
                                    {{msgUtil.message.action.reset}}
                                </Button>
                            </FormItem>
                        </Card>
                    </Row>
                </Col>
            </Form>
        </Row>
    </div>
</template>

<script>
import BaseUrl from '_conf/url';
import axios from 'axios';
import { getTreeMenuList } from '@/api/menu';
import { getTagList } from '@/api/tag';
import { add, getImageSizeInfo } from '@/api/article';
import { getDictArticleList } from '@/api/dict';
import { VueCropper } from 'vue-cropper';
import { uploadImg } from '@/api/image';
// import { uploadNr } from "@/api/image";
export default {
    name: 'content_article_add',
    components: {
        VueCropper,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            t: t,
            self: this,
            msgUtil: msgUtil,
            option: {
                bkImg: '',
                img: '',
                outputSize: 1,
                //输出图片格式
                outputType: 'png',
                info: true,
                //截图信息展示是否是真实的输出宽高
                infoTrue: true,
                //是否输出原图比例的截图
                full: false,
                //能否拖动图片
                canMove: true,
                //能否拖动截图框
                canMoveBox: true,
                //截图框固定大小
                fixedBox: true,
                //上传图片是否显示原始宽高 (针对大图 可以铺满)
                original: false,
                //是否自动生成截图框
                autoCrop: true,
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 0,
                autoCropHeight: 0,
                //截图框是否限制在图片里(只有在自动生成截图框时才能生效)
                centerBox: false,
                //是否根据dpr生成适合屏幕的高清图片
                high: true,
                //是否按照截图框比例输出 默认为1
                enlarge: 1,
                cropData: {},
            },
            showCropper: false,
            showCropperButton: false,
            imageSizeList: [],
            dictArticleList: [],
            currentDictArticleInfo: null,
            thumbWidth: 0,
            showImageFlg: false,
            showImage: null,
            showImageName: null,
            formItem: {
                dictId: '',
                title: '',
                author: '',
                thumb: null,
                thumb1: null,
                image: null,
                description: '',
                body: '',
                version: 1,
                hot: null,
                recommend: null,
                recommendTop: null,
                topic: null,
                top: null,
                slider: null,
                hits: 0,
                charge: '1',
                status: '9',
                disabled: '1',
                selectedMenuId: '',
                tagIdList: [],
                imageSizeIndex: -1,
                imageSizeType: '',
                category: '',
                releaseTime: '',
            },
            ruleValidate: {
                title: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.article.title),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 64,
                        message: msgUtil.errorMaxLengthFullWidth(t.article.title, 64),
                        trigger: 'blur',
                    },
                ],
                thumb: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.article.thumb),
                        trigger: 'blur',
                    },
                ],
                image: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.article.image),
                        trigger: 'blur',
                    },
                ],
                top: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.article.top),
                        trigger: 'blur',
                    },
                ],
                description: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.article.description),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 30000,
                        message: msgUtil.errorMaxLengthFullWidth(t.article.description, 30000),
                        trigger: 'blur',
                    },
                ],
                author: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.article.author),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 20,
                        message: msgUtil.errorMaxLengthFullWidth(t.article.author, 20),
                        trigger: 'blur',
                    },
                ],
                tagIdList: [
                    {
                        type: 'array',
                        required: true,
                        message: msgUtil.errorRequired(t.article.tagName),
                        trigger: 'blur',
                    },
                ],
            },
            toolbar1:
                'newnote print preview code | undo redo | insert | styleselect | fontsizeselect | fontselect | forecolor backcolor bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image emoticons media codesample',
            other_options: {
                height: 400,
                menubar: false,
                plugins: 'image code print preview',
                images_upload_handler: function(blobInfo, success, failure) {
                    let param = new FormData(); //创建form对象
                    param.append('image', blobInfo.blob(), blobInfo.filename()); //通过append向form对象添加数据
                    axios
                        .post(BaseUrl.dataUrl + '/image/scale/', param)
                        .then(response => success(BaseUrl.Url + response.data.url));
                },
            },
            paramTag: {
                status: '1',
                size: '99999',
                oa: 'sortOrder',
            },
            paramMenuTree: {
                division: '1',
            },
            menuList: [],
            menuListBk: [],
            tagList: [],
            treeNodeError: false,
            loading: false,
            releaseTimeOption: {},
        };
    },
    beforeCreate() {
        import('tinymce-i18n/langs/ja');
    },
    computed: {
        showImageModalWidth() {
            return this.thumbWidth;
        },
        showMustItem() {
            return this.formItem.category === '';
        },
    },
    methods: {
        async handleSubmit() {
            if (this.formItem.selectedMenuId === '') {
                this.treeNodeError = true;
                return;
            }
            if (this.formItem.description === '') {
                let content = this.$refs.tinymceArt.editor.getContent({ format: 'text' });
                if (content != null && content.length > 0) {
                    content = content.replace(/(^\s*)|(\s*$)/g, '').substring(0, 75);
                }
                this.formItem.description = content;
            }
            if (this.formItem.author === '') {
                this.formItem.author = 'admin';
            }
            if (this.formItem.releaseTime instanceof Date) {
                this.formItem.releaseTime = this.formItem.releaseTime.format('yyyy/MM/dd HH:mm:ss');
            }
            this.loading = true;
            this.$Loading.start();
            if (await this.$refs['form'].validate()) {
                let articleDto = {};
                articleDto.dictId = this.formItem.dictId;
                articleDto.title = this.formItem.title;
                articleDto.author = this.formItem.author;
                articleDto.thumb = this.formItem.thumb;
                articleDto.image = this.formItem.image;
                articleDto.description = this.formItem.description;
                articleDto.body = this.formItem.body;
                articleDto.hot = this.formItem.hot;
                articleDto.recommend = this.formItem.recommend;
                articleDto.recommendTop = this.formItem.recommendTop;
                articleDto.topic = this.formItem.topic;
                articleDto.slider = this.formItem.slider;
                articleDto.top = this.formItem.top;
                articleDto.hits = this.formItem.hits;
                articleDto.charge = this.formItem.charge;
                articleDto.status = this.formItem.status;
                articleDto.disabled = this.formItem.disabled;
                articleDto.selectedMenuId = this.formItem.selectedMenuId;
                articleDto.tagIdList = this.formItem.tagIdList;
                articleDto.releaseTime = this.formItem.releaseTime;
                await add(articleDto);
                this.$Loading.finish();
                this.$Message.success(this.msgUtil.message.action.addSuccess);
                this.handleReset();
            } else {
                this.$Loading.error();
                this.$Message.error(this.msgUtil.message.action.addFail);
            }
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            this.$refs.form1.resetFields();
            this.$refs.cropper.clearCrop();
            this.menuList = JSON.parse(JSON.stringify(this.menuListBk));
            this.formItem.body = '';
            this.formItem.category = '';
            this.option.img = null;
            this.formItem.imageSizeIndex = -1;
            this.formItem.imageSizeType = null;
            this.loading = false;
        },
        //类别选择
        categoryChange(index) {
            if (index !== undefined && index !== '') {
                this.currentDictArticleInfo = this.dictArticleList[index];
                this.showCropper = false;
                this.formItem.dictId = this.currentDictArticleInfo.id;
            } else {
                this.currentDictArticleInfo = null;
                this.formItem.category = '';
                this.formItem.dictId = '';
            }
        },
        onReleaseTimeChange(releaseTime) {
            this.formItem.releaseTime = releaseTime;
        },
        showDictThumb(step) {
            if (this.currentDictArticleInfo == null) {
                return null;
            }
            if (step === 1) {
                return this.currentDictArticleInfo.image;
            } else if (step === 2) {
                return this.currentDictArticleInfo.thumb;
            } else if (step === 3) {
                return this.currentDictArticleInfo.slider;
            } else if (step === 4) {
                return this.currentDictArticleInfo.recommendTop;
            } else if (step === 5) {
                return this.currentDictArticleInfo.recommend;
            } else if (step === 6) {
                return this.currentDictArticleInfo.hot;
            } else if (step === 7) {
                return this.currentDictArticleInfo.topic;
            } else if (step === 8) {
                return this.currentDictArticleInfo.top;
            }
        },
        //图片预览
        onShowDictThumbClick(step) {
            if (step === 1) {
                this.showImage = this.currentDictArticleInfo.image;
                this.showImageName = this.currentDictArticleInfo.imageName;
                this.thumbWidth = this.currentDictArticleInfo.imageWidth;
            } else if (step === 2) {
                this.showImage = this.currentDictArticleInfo.thumb;
                this.showImageName = this.currentDictArticleInfo.thumbName;
                this.thumbWidth = this.currentDictArticleInfo.thumbWidth;
            } else if (step === 3) {
                this.showImage = this.currentDictArticleInfo.slider;
                this.showImageName = this.currentDictArticleInfo.sliderName;
                this.thumbWidth = this.currentDictArticleInfo.sliderWidth;
            } else if (step === 4) {
                this.showImage = this.currentDictArticleInfo.recommendTop;
                this.showImageName = this.currentDictArticleInfo.recommendTopName;
                this.thumbWidth = this.currentDictArticleInfo.recommendTopWidth;
            } else if (step === 5) {
                this.showImage = this.currentDictArticleInfo.recommend;
                this.showImageName = this.currentDictArticleInfo.recommendName;
                this.thumbWidth = this.currentDictArticleInfo.recommendWidth;
            } else if (step === 6) {
                this.showImage = this.currentDictArticleInfo.hot;
                this.showImageName = this.currentDictArticleInfo.hotName;
                this.thumbWidth = this.currentDictArticleInfo.hotWidth;
            } else if (step === 7) {
                this.showImage = this.currentDictArticleInfo.topic;
                this.showImageName = this.currentDictArticleInfo.topicName;
                this.thumbWidth = this.currentDictArticleInfo.topicWidth;
            } else if (step === 8) {
                this.showImage = this.currentDictArticleInfo.top;
                this.showImageName = this.currentDictArticleInfo.topName;
                this.thumbWidth = this.currentDictArticleInfo.topWidth;
            }
            this.showImageFlg = true;
        },

        onImageSizeChange(index) {
            const imageSizeInfo = this.imageSizeList[index];
            this.option.autoCropWidth = parseInt(imageSizeInfo.width);
            this.option.autoCropHeight = parseInt(imageSizeInfo.height);
            this.$refs.cropper.changeCrop(this.option.autoCropWidth, this.option.autoCropHeight);
            this.formItem.imageSizeType = imageSizeInfo.range;
            if (this.formItem.imageSizeType === 'image') {
                this.option.img = this.formItem.image;
            } else if (this.formItem.imageSizeType === 'thumb') {
                this.option.img = this.formItem.thumb;
            } else if (this.formItem.imageSizeType === 'slider') {
                this.option.img = this.formItem.slider;
            } else if (this.formItem.imageSizeType === 'recommendTop') {
                this.option.img = this.formItem.recommendTop;
            } else if (this.formItem.imageSizeType === 'recommend') {
                this.option.img = this.formItem.recommend;
            } else if (this.formItem.imageSizeType === 'hot') {
                this.option.img = this.formItem.hot;
            } else if (this.formItem.imageSizeType === 'topic') {
                this.option.img = this.formItem.topic;
            } else if (this.formItem.imageSizeType === 'top') {
                this.option.img = this.formItem.top;
            }
            if (!this.option.img) {
                this.option.img = this.option.bkImg;
            }
            this.showCropperButton = true;
        },
        changeShowCropper() {
            this.showCropper = !this.showCropper;
        },
        handleBeforeUpload(file) {
            //上传图片
            if (!/^image/.test(file.type) || !/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
                this.$Notice.warning({
                    title: this.msgUtil.message.file.error.format,
                    desc:
                        this.msgUtil.message.file.name +
                        '{' +
                        file.name +
                        '}' +
                        this.msgUtil.message.file.error.typeFormat,
                    duration: 15,
                });
                return false;
            }
            const reader = new FileReader();
            reader.onload = e => {
                let data;
                //console.log(e);
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                    data = e.target.result;
                }
                this.option.img = data;
                if (this.formItem.imageSizeType === 'image') {
                    this.option.bkImg = data;
                }
            };

            // 转化为base64
            // reader.readAsDataURL(file)
            // 转化为blob
            reader.readAsArrayBuffer(file);
            return false;
        },
        // 实时预览函数
        realTime(data) {
            //console.log(data);
        },
        handleUpload() {
            this.$refs.cropper.getCropBlob(data => {
                //var blobObject = new Blob([data]);
                const formData = new FormData();
                formData.append('image', data);
                uploadImg(formData).then(d => {
                    if (this.formItem.imageSizeType === 'image') {
                        this.formItem.image = BaseUrl.Url + d.url;
                    } else if (this.formItem.imageSizeType === 'thumb') {
                        this.formItem.thumb = BaseUrl.Url + d.url;
                    } else if (this.formItem.imageSizeType === 'slider') {
                        this.formItem.slider = BaseUrl.Url + d.url;
                    } else if (this.formItem.imageSizeType === 'recommendTop') {
                        this.formItem.recommendTop = BaseUrl.Url + d.url;
                    } else if (this.formItem.imageSizeType === 'recommend') {
                        this.formItem.recommend = BaseUrl.Url + d.url;
                    } else if (this.formItem.imageSizeType === 'hot') {
                        this.formItem.hot = BaseUrl.Url + d.url;
                    } else if (this.formItem.imageSizeType === 'topic') {
                        this.formItem.topic = BaseUrl.Url + d.url;
                    } else if (this.formItem.imageSizeType === 'top') {
                        this.formItem.top = BaseUrl.Url + d.url;
                    }
                });
            });
        },
        imgLoad(msg) {
            //console.log(msg);
        },
        cropMoving(data) {
            this.option.cropData = data;
        },
        selectedTreeNode(val) {
            // console.log(val[0].id);
            this.treeNodeError = false;
            this.formItem.selectedMenuId = val[0].id;
        },
        clearField(event) {
            event.target.offsetParent.children[1].value = '';
        },
    },
    async mounted() {
        //得到图片大小情报
        const imageSizeInfo = await getImageSizeInfo();
        if (imageSizeInfo.imageSizeList != null) {
            this.imageSizeList = imageSizeInfo.imageSizeList;
        }
        //得到前台所有菜单展示
        const treeMenuList = await getTreeMenuList(this.paramMenuTree);
        if (treeMenuList.menus != null) {
            this.menuList = treeMenuList.menus;
            this.menuListBk = JSON.parse(JSON.stringify(treeMenuList.menus));
        }
        //得到标签数据集
        const tagList = await getTagList(this.paramTag);
        if (tagList.page != null) {
            this.tagList = tagList.page.records;
        }

        //得到字典数据
        const dictArticles = await getDictArticleList();
        if (dictArticles.dicts != null) {
            this.dictArticleList = dictArticles.dicts;
        }
    },
};
</script>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.sub-cropper {
    height: 600px;
    margin-bottom: 10px;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1080px) {
    .sub-cropper {
        height: 600px;
    }
}

.article-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}

.article-upload-list img {
    width: 100%;
    height: 100%;
}

.article-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}

.article-upload-list:hover .article-upload-list-cover {
    display: block;
}

.article-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
